import { Navigate, Route } from "react-router-dom";

import { AuthLayout } from "@/components/Layouts";
import { RootErrorBoundary } from "@/components/RootErrorBoundary";
import {
  ForgotPasswordPage,
  ResetPasswordPage,
  SignInPage,
  SSOLoginPage,
} from "./lazyPages";

export const authRoutes = (
  <Route
    key="auth"
    path="/auth"
    element={<AuthLayout />}
    ErrorBoundary={RootErrorBoundary}
  >
    <Route key="sign-in" path="sign-in" element={<SignInPage />} />,
    <Route
      key="reset-password"
      path="reset-password"
      element={<ResetPasswordPage />}
    />
    ,
    <Route
      key="forgot-password"
      path="forgot-password"
      element={<ForgotPasswordPage />}
    />
    ,
    <Route key="sso-login" path="sso-login" element={<SSOLoginPage />} />,
    <Route key="*" path="*" element={<Navigate to="/auth/sign-in/" />} />
  </Route>
);
